import { FC } from 'react'
import { IconButton, TextField, InputAdornment } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { toSpliced } from '../../../../utils/functions'

interface IProps {
  value: Array<string>
  onChange: (vals: Array<string>) => void
  className: string
  label: string
}

/*
 * Show multiple TextFields, with [+] and [-] buttons to make more/less.
 *
 * TODO: This could be a list of *any* scalar control, instead of just for TextField.
 */
const TextFieldList: FC<IProps> = ({ value, onChange, className, label }) => {
  // Handle legacy single-line values:
  if (value.constructor !== Array) value = [value as unknown as string]

  // Make sure we show at least one field:
  if (value.length === 0) value = ['']

  return (
    <>
      {value?.map((line, i) => {
        return (
          <TextField
            key={i.toString()}
            value={line || ''}
            onChange={(ev) => onChange(toSpliced(value, i, 1, ev.target.value))}
            className={className}
            label={label}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => onChange(toSpliced(value, i, 1))}>
                    <RemoveIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )
      })}
      <IconButton onClick={() => onChange([...value, ''])}>
        <AddIcon />
      </IconButton>
    </>
  )
}

export default TextFieldList
